(() => {
  if (window.__forthiqPdpPerformanceLoaded) return;
  window.__forthiqPdpPerformanceLoaded = true;

  const normaliseUrl = (url) =>
    typeof url === "string" && url.startsWith("//") ? `https:${url}` : url;

  const readModels = () => {
    const node = document.getElementById("ForthiqDeferredProductModelsJSON");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      console.error("FORTHiQ deferred 3D model data is invalid", error);
      return [];
    }
  };

  const loadShopifyFeature = (name, onLoad) => {
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{ name, version: "1.0", onLoad }]);
  };

  const initialiseViewer = (viewer) => {
    loadShopifyFeature("model-viewer-ui", () => {
      if (window.Shopify?.ModelViewerUI) {
        new window.Shopify.ModelViewerUI(viewer);
      }
    });
  };

  const initialiseXr = (models) => {
    loadShopifyFeature("shopify-xr", () => {
      const setup = () => {
        if (!window.ShopifyXR) return;
        window.ShopifyXR.addModels(models);
        window.ShopifyXR.setupXRElements();
        document.querySelectorAll("[data-shopify-xr]").forEach((button) => {
          button.removeAttribute("data-shopify-xr-hidden");
        });
      };
      if (window.ShopifyXR) setup();
      else document.addEventListener("shopify_xr_initialized", setup, { once: true });
    });
  };

  const activateModel = (button) => {
    if (button.dataset.modelLoading === "true") return;
    button.dataset.modelLoading = "true";

    const models = readModels();
    const model = models.find((item) => String(item.id) === button.dataset.modelId);
    const glb = model?.sources?.find((source) => source.format === "glb");
    const usdz = model?.sources?.find((source) => source.format === "usdz");
    const slide = button.closest("[data-model-slide]");
    if (!model || !glb || !slide) {
      button.dataset.modelLoading = "false";
      return;
    }

    const viewer = document.createElement("model-viewer");
    viewer.setAttribute("src", normaliseUrl(glb.url));
    if (usdz?.url) viewer.setAttribute("ios-src", normaliseUrl(usdz.url));
    if (model.preview_image?.src) {
      viewer.setAttribute("poster", normaliseUrl(model.preview_image.src));
    }
    viewer.alt = button.dataset.productTitle || "Interactive 3D product model";
    viewer.setAttribute("camera-controls", "true");
    viewer.setAttribute("data-shopify-feature", "1.12");
    viewer.style.cssText = "display:block;width:100%;height:100%;--poster-color:transparent";

    const poster = slide.querySelector(".js-product-media-model-poster");
    if (poster) poster.hidden = true;
    slide.insertBefore(viewer, button);
    button.remove();

    initialiseViewer(viewer);
    initialiseXr(models);
  };

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(".js-forthiq-deferred-model-button");
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      activateModel(button);
    },
    true,
  );
})();
